'use strict';

exports.__esModule = true;
exports.default = {
  contains: function contains(obj, prop, message) {
    if (!obj[prop]) {
      throw Error(message || 'Required property ' + prop + ' missing');
    }
  },
  exists: function exists(prop, message) {
    if (!prop) {
      throw Error(message || '');
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-fetch/lib/utils/assert.js
// module id = 691
// module chunks = 0